export const setAuthToken = (key: string, token: string) => localStorage.setItem(`${key}@authToken`, JSON.stringify(token));

export const getAuthToken = (key: string): string => {
    const token = localStorage.getItem(`${key}@authToken`) || '';

    if (!token) {
        return '';
    }

    return JSON.parse(token);
};

export const removeAuthToken = (key: string) => localStorage.removeItem(`${key}@authToken`);
